// This is generated.  Alter it in blockGroups/actionElements/types/FindRecord.js
/* eslint-disable no-unused-vars */
const { config, moduleRegistration } = require('@sstdev/lib_metadata-config');
const { merge } = require('lodash');
module.exports = {
  asDataDictionary: function asDataDictionary(hNode, context) {
    const { namespace, relation, filters = [] } = hNode;

    // Collect contributions from filters
    const filterGroup = moduleRegistration.getHNodeTypeGroup('filters');

    let mergedSubDD = {};
    let mergedPartialMap = {};

    for (const lc of filters) {
      const [cSub = {}, cPartial = {}] = (filterGroup &&
      typeof filterGroup.asDataDictionary === 'function'
        ? filterGroup.asDataDictionary(lc, { ...context, namespace, relation })
        : [{}, {}]) || [{}, {}];

      mergedSubDD = merge(mergedSubDD, cSub);
      mergedPartialMap = Object.assign(mergedPartialMap, cPartial);
    }

    // View-only block: only pass through filter subDataDictionary contributions.
    // Do NOT create or merge into the canonical [namespace][relation] slot.
    // Canonical schemas are defined by Form blocks.
    return [mergedSubDD, mergedPartialMap];
  },
};
moduleRegistration.registerHNodeType(
  'actionElements',
  'FindRecord',
  module.exports,
);
